/** Modes d'écran multi-fenêtres — port fidèle de `prototype-cta/app.js` (SCREENS). */

export interface ScreenDef {
  nom: string;
  desc: string;
}

export const SCREENS: Record<string, ScreenDef> = {
  full: { nom: 'Poste complet', desc: 'File + carte + engins + dossier' },
  map: { nom: 'Carte tactique', desc: 'Carte plein écran, idéale sur le 2ᵉ moniteur' },
  queue: { nom: 'File + dossier', desc: 'Interventions et dossier détaillé' },
  units: { nom: "Moniteur d'engins", desc: 'Tableau des moyens en plein écran' },
  synoptique: { nom: 'Synoptique', desc: 'Tableau de bord du périmètre' },
  journal: { nom: 'Main courante', desc: 'Journal radio complet' },
};

export type ScreenKey = keyof typeof SCREENS;

/** Lit le mode d'écran depuis l'URL (`?screen=...`), `full` par défaut. */
export function getScreenFromUrl(): string {
  try {
    const s = new URLSearchParams(window.location.search).get('screen');
    return s && s in SCREENS ? s : 'full';
  } catch {
    return 'full';
  }
}

/** Ouvre une fenêtre secondaire verrouillée sur un mode d'écran. */
export function openScreen(mode: string): void {
  const url = `${window.location.pathname}?screen=${mode}`;
  window.open(url, `opsecours-${mode}`, 'width=1280,height=860,menubar=no,toolbar=no');
}
